import {axiosGet} from "../../../Helpers/AxiosHelper";

const state = {
    pipelineListByMuseum: [],
};
const getters = {
    getPipelineListByMuseum: state => state.pipelineListByMuseum

};

const mutations = {
    PIPELINE_INFO(state, data) {
        state.pipelineListByMuseum = data
    }
};

const actions = {
    getPipelineListByMuseum({commit}) {
        axiosGet(`crm/pipelinesbymuseum`).then((response) => {
            commit('PIPELINE_INFO', response.data)
        }).catch((error) => console.log(error));
    }
};


export default {
    state,
    getters,
    mutations,
    actions
}
